import { render, staticRenderFns } from "./AnswerTable.vue?vue&type=template&id=06fe3092&scoped=true"
import script from "./AnswerTable.vue?vue&type=script&lang=js"
export * from "./AnswerTable.vue?vue&type=script&lang=js"
import style0 from "./AnswerTable.vue?vue&type=style&index=0&id=06fe3092&prod&lang=scss&scoped=true"
import style1 from "./AnswerTable.vue?vue&type=style&index=1&id=06fe3092&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fe3092",
  null
  
)

export default component.exports